import React from "react";
import CountryLayout from "@/components/CountryLayout";

export default function CountryGermany() {
  return <CountryLayout countryKey="germany" countryCode="de" sourcePage="/countries/germany" />;
}
